import { useMemo } from 'react';
import useNavigationNotifications from './useNotifications';

export const getNotificationCountByUrl = (
  notifications: Notifications,
  branchId: string | undefined,
  url: string,
) => {
  const size = (branchId?.length ?? 0) + 1;
  const key = url.substring(size);
  return notifications?.[key];
};

export const getNotificationCountStartWithUrl = (
  notifications: Notifications,
  branchId: string | undefined,
  url: string,
) => {
  const size = (branchId?.length ?? 0) + 1;
  const key = url.substring(size);

  return Object.keys(notifications).reduce((prev, curr) => {
    if (curr.startsWith(key)) {
      prev += notifications[curr] ?? 0;
    }
    return prev;
  }, 0);
};

type Notifications = { [key: string]: number | undefined };

const useRouteNotifications = (): Notifications => {
  const notificationCounts = useNavigationNotifications();
  const notifications: Notifications = useMemo(
    () => ({
      '/vehicles/assignments': notificationCounts.assignments,
      '/leads': notificationCounts.leads,
      '/inbox/messages': notificationCounts.messages,
      '/inbox/online-orders': notificationCounts.orders,
      '/website/forms': notificationCounts.websiteFormSubsmissions,
    }),
    [notificationCounts],
  );

  return notifications;
};

export default useRouteNotifications;
